import { render } from "./WalletConnectWalletModal.vue?vue&type=template&id=87078c4a&scoped=true"
import script from "./WalletConnectWalletModal.vue?vue&type=script&lang=js"
export * from "./WalletConnectWalletModal.vue?vue&type=script&lang=js"

import "./WalletConnectWalletModal.vue?vue&type=style&index=0&id=87078c4a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87078c4a"]])

export default __exports__